/**
 * The layout route element for the work-pipeline screens — a `ToastProvider`
 * around an `Outlet`, and deliberately nothing else.
 *
 * Same reasoning as `features/quotes/providers.tsx`: `routes.tsx` stays route
 * METADATA (one `RouteObject[]` export, no component declarations), because
 * declaring a component beside the array breaks Fast Refresh for the module — an
 * edit to the array would remount the provider and drop whatever toast was on
 * screen.
 *
 * ONE provider for both routes rather than one per page: the record screen's
 * mutations report through toasts, and navigating board → record must not unmount
 * the stack mid-message.
 */

import { Outlet } from 'react-router-dom';
import { ToastProvider } from '../inquiries/toast';

export function WorkProviders(): React.JSX.Element {
  return (
    <ToastProvider>
      <Outlet />
    </ToastProvider>
  );
}
